export default __webpack_public_path__ + "assets/card-logo-mastercard-component.6ef1bcb4.svg";